import { styled, Typography } from '@mui/material'
import { FC } from 'react'
import { Trans } from 'react-i18next'

const Text = styled(Typography)`
  display: inline;
  font-size: 16px;
  font-weight: 300;
`

const ColorText = styled(Text)`
  font-size: 18px;
  font-weight: 700;
`

const FirstColorText = styled(ColorText)`
  color: orange;
`

const SecondColorText = styled(ColorText)`
  color: red;
`

const ApeironTwoColorMessage: FC<Props> = props => {
  const { className, message } = props

  return (
    <Text className={className}>
      <Trans
        components={{
          color1: <FirstColorText className='Custom-First-Color-Text' />,
          color2: <SecondColorText className='Custom-Second-Color-Text' />
        }}
      >
        {message}
      </Trans>
    </Text>
  )
}

type Props = {
  className?: string
  message: string
}

export default ApeironTwoColorMessage
